<div class="main">
    <div class="loader" *ngIf="showLoader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="head">
        <div class="label">
            {{ "PARTIALREGISTRATION.title" | translate }}
        </div>
    </div>
    <div class="vehicle_search">
        <div>
            <input type="text" class="input_search" placeholder="Search Vehicle Details" [(ngModel)]="vehicle_number">
        </div>
        <div class="vehicle_search_btn"(click)="searchVehicleDetails()">
            <span>Search</span>
        </div>
    </div>
    <div class="section">
        
        <div class="body">
            <div class="left">
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.driverName" | translate
                        }}<span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotDriverData.name" autocomplete="off" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.vehicleNum" | translate
                        }}<span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.vehicle_no" [placeholder]="vehicle_pattern"
                        autocomplete="off" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.license" | translate }}
                        <sup style="color: #e54131; font-weight: 900">*</sup>
                    </div>
                    <input [(ngModel)]="spotVehicleData.driver_licence_no" type="text" autocomplete="off" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.carrierType" | translate }}
                    </div>

                    <mat-select class="inputSelect" style="height: 100%;background-color: #fff;border-radius: 5px;padding: 4px;width: 100%;"  
                    [(ngModel)]="carrier_type">
                        <mat-option *ngFor="let type of carrierTypes" [value]="type">
                            {{ type }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.vehicle_qty" | translate }}
                        <sup style="color: #e54131; font-weight: 900">*</sup>
                    </div>
                    <input [(ngModel)]="capacityData.vehicle_qty" (keyup)="applyFilter($event.target.value)" type="text"
                        autocomplete="off" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.rc_Laden_weight" | translate }}
                        <sup style="color: #e54131; font-weight: 900">*</sup>
                    </div>
                    <input [(ngModel)]="capacityData.rc_Laden_weight" (keyup)="applyFilter($event.target.value)"
                        type="text" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.preferred_zone" | translate }}
                    </div>
                    <div class="input_dropdown">
                        <input type="text" class="formField" required="required" [matAutocomplete]="orgPlace"
                            [(ngModel)]="preferred.zone" />
                        <mat-autocomplete #orgPlace="matAutocomplete">
                            <mat-option *ngFor="let org of states | filter: preferred.zone" [value]="org.name">
                                <span>{{ org.name }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.location" | translate}}
                        <span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="preferred.location" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.insuranceno" | translate}}
                    </div>
                    <input type="number" min="0" [(ngModel)]="insurance.no" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.customer_name" | translate}}
                    </div>
                    <input type="text" [(ngModel)]="customer_name" />
                </div>
            </div>
            <div class="right">
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.mobile" | translate}}
                        <span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotDriverData.mobile" autocomplete="off" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.vehicleType" | translate}}
                        <span>
                            <sup style="color: #ff0000">*</sup>
                        </span>
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField" style="height: 100%;background-color: #fff;border: solid 1px #e3e3e3;border-radius: 5px;width: 100%;" 
                        [(ngModel)]="vehicle">
                            <mat-option *ngFor="let vehicle of allVehicles" [value]="vehicle._id">
                                {{ vehicle.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.licenseExpiryDate" | translate}}
                        <span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <div class="formInput">
                        <input type="text" name="expiryDate" [matDatepicker]="picker" [(ngModel)]="expiryDate"
                            (click)="picker.open()" autocomplete="off" />
                        <mat-datepicker #picker (closed)="setExpiryDate(expiryDate, 'change','licence_expiry')">
                        </mat-datepicker>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.dedicated" | translate}}
                        <span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField" style="height: 100%;background-color: #fff;border: solid 1px #e3e3e3;border-radius: 5px;width: 100%;" 
                        [(ngModel)]="dedicated_to">
                            <mat-option *ngFor="let unit of shippersArr" [value]="unit._id">
                                {{ unit.name }}
                            </mat-option>
                        </mat-select>
                      </div>
                </div>
                
               
                <div *ngFor="let mat of materialList; let last = last; let i = index; let first = first;">
                    <div class="material_sec">
                        <div class="add_material">
                            <div class="inputContainer">
                                <div class="label">
                                    {{ "Materials" | translate }}
                                </div>
                                <mat-select
                                    style="border: solid 1px #e3e3e3;padding: 4px;border-radius: 5px;align-items: center;"
                                    [(ngModel)]="mat.name" class="formField" required="required"
                                    >
                                    <mat-option *ngFor="let mater of materialsArr"
                                        (onSelectionChange)="selectMaterial(mat, $event,i)" [value]="mater.name">
                                        {{mater.name}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="add_load">
                            <div class="inputContainer">
                                <div class="label">
                                    {{ "Load" | translate }}
                                </div>
                                <input [(ngModel)]="mat.load" [disabled]="enbleMaterial" type="text"
                                    autocomplete="off" /> 
                            </div>
                        </div>
                        <div class="material_action">
                            <div *ngIf="!first" (click)="removeMaterial(i)">
                                <img src="assets/del.svg" alt="">
                            </div>
                            <div *ngIf="last && mat.name" (click)="addMaterial()">
                                <img src="assets/plus.svg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.capacity" | translate }}
                        <sup style="color: #e54131; font-weight: 900">*</sup>
                    </div>
                    <input [(ngModel)]="capacityData.capacity" type="text" autocomplete="off" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.insuranceexpirydate" | translate}}
                        <span><sup style="color: #ff0000">*</sup></span>
                    </div>
                    <div class="formInput">
                        <input type="text" name="invExpiryDate" [matDatepicker]="picker1" [(ngModel)]="insurance.expiry"
                            (click)="picker1.open()" (closed)="setExpiryDate(insurance.expiry, 'change','invExpiry')"
                            autocomplete="off" />
                        <mat-datepicker #picker1></mat-datepicker>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.chassisno" | translate}}
                    </div>
                    <input type="text" [(ngModel)]="chassis_number" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "PARTIALREGISTRATION.engineno" | translate}}
                    </div>
                    <input type="text" [(ngModel)]="engine_number" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'PARTIALREGISTRATION.gps' | translate}}
                    </div>
                    <mat-select class="inputSelect"
                        style="border: solid 1px #e3e3e3;padding: 5px;border-radius: 5px;align-items: center;"
                        [(ngModel)]="selectedGPSProvider">
                        <mat-option *ngFor="let provider of gps_providers" [value]="provider.name">
                            {{provider.name}}
                        </mat-option>
                    </mat-select>
                </div>

                
            </div>

        </div>
        <div class="submitButton" (click)="addSpotVehicle()">
            <div class="button">
                {{ "PARTIALREGISTRATION.add_vehicle" | translate }}
            </div>
        </div>
    </div>
   
</div>